import { render, staticRenderFns } from "./eyes.vue?vue&type=template&id=773db8b8&scoped=true"
import script from "./eyes.vue?vue&type=script&lang=js"
export * from "./eyes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773db8b8",
  null
  
)

export default component.exports